import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';

import { ActionButton, CancelButton, CustomDialogTitle } from 'components';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { useSmallScreen } from 'utils/hooks/ui';

const ConfirmDialog = props => {
    const {
        children,
        open,
        loading,
        title,
        confirmText = texts.OUI,
        cancelText = texts.NON,
        handleClose,
        handleCancel,
        handleConfirm,
        disableConfirm,
        hideCancelButton,
    } = props;

    const fullScreen = useSmallScreen();

    const cancelHandler = useCallback(
        e => {
            handleCancel?.();
            handleClose(e);
        },
        [handleCancel, handleClose]
    );

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            sx={theme => ({ [theme.breakpoints.down('sm')]: { minWidth: 'unset' } })}
            onClick={e => e.stopPropagation()}
            onKeyDown={e => e.stopPropagation()}
            onKeyUp={e => {
                if (e.key === 'Enter') {
                    handleConfirm();
                }
            }}
        >
            <CustomDialogTitle title={title} handleClose={loading ? null : handleClose} />
            <DialogContent
                sx={theme => ({ color: theme.palette.grey[600], padding: theme.spacing(2, 3) })}
            >
                {children}
            </DialogContent>
            <DialogActions>
                {!hideCancelButton && (
                    <CancelButton
                        disabled={loading}
                        onClick={cancelHandler}
                        sx={{ padding: '3px 5px' }}
                    >
                        {cancelText}
                    </CancelButton>
                )}
                <ActionButton
                    size="small"
                    sx={{ padding: '3px 5px' }}
                    loading={loading}
                    disabled={loading || disableConfirm}
                    onClick={handleConfirm}
                >
                    {confirmText}
                </ActionButton>
            </DialogActions>
        </Dialog>
    );
};

ConfirmDialog.propTypes = {
    children: PropTypes.node,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    handleCancel: PropTypes.func,
    loading: PropTypes.bool,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    title: PropTypes.string,
    hideCancelButton: PropTypes.bool,
    disableConfirm: PropTypes.bool,
};

export default ConfirmDialog;
